import React, { ReactNode } from "react";
import { Badge, styled } from "@mui/material";

interface Props {
  color: string;
  content?: ReactNode;
}

const PulsingBadge: React.FC<Props> = (props) => {
  const { color, content } = props;

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      zIndex: 2000,
      height: "12px",
      width: "12px",
      borderRadius: "6px",
      backgroundColor: color,
      color: color,
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  }));

  return (
    <StyledBadge
      overlap="circular"
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      variant="dot"
    >
      {content}
    </StyledBadge>
  );
};

export default PulsingBadge;
